var _circle, _circle2, _circle3, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFace2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 43.31,
    fill: "#bbb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.75,
    cy: 35.02,
    r: 6.31,
    fill: "#888"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.25,
    cy: 35.02,
    r: 6.31,
    fill: "#888"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.25,63.72A2.13,2.13,0,0,1,28,59.83a33.42,33.42,0,0,1,10.58-4.39A28.82,28.82,0,0,1,62,59.83a2.13,2.13,0,0,1-2.42,3.51h0a24.7,24.7,0,0,0-10.65-4.22,25.86,25.86,0,0,0-9.32.47,29.19,29.19,0,0,0-9.11,3.75A2.14,2.14,0,0,1,29.25,63.72Z",
    fill: "#6a6a6a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.24,12.17a43.3,43.3,0,0,1-62.73,59,43.31,43.31,0,1,0,62.73-59Z",
    fill: "#b3b3b3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace2);
export default __webpack_public_path__ + "static/media/face_2.3f5e42c3531c7e385e4a804bd8bb5598.svg";
export { ForwardRef as ReactComponent };